import { TypeRequest } from "../common/enums/AllEnums";
import { IAnswerDetail, IFormAnswer } from "../interfaces/IAnswer";
import { IResponse } from "../interfaces/IResponse";
import { BisApiRequest } from "./apis"

export const GetSurvey = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Encuesta/ObtenerFormularios', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const getFormsListDetailsPagedByFormID = (FormID: number,NameOrCode: string='', page?:number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerFormularioListadoDetallePaginadoByFormularioID?formularioID=${FormID}&filtro=${NameOrCode}&pagina=${page}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const getAndBlockFormsListDetailsPagedByFormID = (FormID: number,): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerAndBoquearFormularioListadoDetalleByFormularioID?formularioID=${FormID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const getFormsDetailsByFormListDetailID = (FormListDetailID: number,NameOrCode: string=''): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerFormularioDetalleByFormularioListadoDetalleID?formularioListadoDetalleID=${FormListDetailID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const ActiveOrBlockFormListDetail = (formDetalleId:number, action:boolean): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ActivarOrBloquearFormularioListadoDetalleByID?formularioListadoDetalleID=${formDetalleId}&bloquear=${action}`,TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const ActiveFormListDetailByFormID = (FormID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ActivarFormularioListadoDetalleByFormularioID?formularioID=${FormID}`, TypeRequest.put).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}



export const GetFormsHistoric = (): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest('/Encuesta/ObtenerFormulariosHistorico', TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const GetFormsHistoricByDates = (minDate: string='',maxDate: string=''): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerFormulariosHistoricoByFechas?fechaDesde=${minDate}&fechaHasta=${maxDate}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const GetFormsHistoricByFormID = (FormID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerFormulariosHistoricoByFormularioID?FormularioID=${FormID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const GetAnswerHistoricByAnswerID = (answerID: number): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerRespuestaHistoricoByRespuestaID?respuestaID=${answerID}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}
export const GetAnswerHistoricByDates = (formId: number,minDate: string='',maxDate: string=''): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ObtenerFormulariosHistoricoByFormularioIDAndFechas?formularioID=${formId}&fechaDesde=${minDate}&fechaHasta=${maxDate}`, TypeRequest.get).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const UpdateAnswer = (answerID: number, listAnswer:IAnswerDetail[]): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/ActualizarRespuesta?respuestaID=${answerID}`, TypeRequest.put, listAnswer).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}

export const InsertFormAnswered = (formAnswered: IFormAnswer): Promise<IResponse> => {
    return new Promise<IResponse>((resolve, reject) => {
        BisApiRequest(`/Encuesta/InsertarRespuesta`, TypeRequest.post, formAnswered).then((response) => {
            resolve(response.data);
        }).catch((error: any) => {
            reject(error?.response?.data);
        });
    })
}